import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=4f495d8c&scoped=true"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"
import style0 from "./Timetable.vue?vue&type=style&index=0&id=4f495d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f495d8c",
  null
  
)

export default component.exports